module.exports = __webpack_public_path__ + "media/images/pages/bg_area_02-4dc8aa36f324e181756b587f62bff630.png";